module.exports = __webpack_public_path__ + "static/media/addPortfolioItem.30e38929.svg";